import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 text-center px-4">
      <h1 className="fw-800 text-primary display-4 mb-2">404</h1>
      <p className="text-muted mb-4">Sorry, we couldn't find the designer you wanted.</p>
      <Link to="/" className="btn btn-primary">
        Go Home
      </Link>
    </div>
  );
}
